import * as React from "react";
import {BaseFormViewState, default as BaseFormView} from "../../../ui/form/BaseFormView";
import FormButtonsView from "../../../ui/form/FormButtonsView";
import JobStatus from "../../../../model/job/JobStatus";
import ButtonPrimary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import ButtonTertiary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import FinanceProduct from "../../../../model/financeProduct/FinanceProduct";
import FinanceProductForm from "../FinanceProductForm";
import FinanceProductFormBody from "../FinanceProductFormBody";

interface IComponentProps {
	/**
	 * On submit callback. Should call only when form is valid.
	 * @param {FinanceProduct} data edited finance product data.
	 */
	onSubmit: (data: FinanceProduct) => void;
	/**
	 * On cancel button handler.
	 */
	onCancel: () => void;
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
	/**
	 * Finance product to edit
	 */
	editedFinanceProduct: FinanceProduct;
}

type IState = BaseFormViewState<FinanceProductForm>;

export default class EditFinanceProductFormView extends BaseFormView<FinanceProductForm, IComponentProps, IState> {
	constructor(props: IComponentProps) {
		super(props);
		this.state = {
			form: FinanceProductForm.createFromFinanceProduct(this.props.editedFinanceProduct),
			isFormDirty: false,
			shouldValidate: false
		};
	}

	render() {
		return (
			<div>
				<FinanceProductFormBody form={this.state.form}
										onFieldChange={this.onFieldChanged}
										onFieldCompleted={this.onFieldCompleted}
										onFocusChange={this.onFocusChange}
										onFieldsChange={this.onFieldsChanged}/>
				<FormButtonsView align={"right"}>
					<ButtonTertiary onClick={this.props.onCancel}
									label={"Cancel"}
									disabled={this.props.isSubmitting}/>
					<ButtonPrimary onClick={() => this.submitForm()}
								   label={"Update Finance product"}
								   disabled={this.props.isSubmitting}
								   isLoading={this.props.isSubmitting}/>
				</FormButtonsView>
			</div>
		);
	}

	submitForm(): void {
		this.setState({shouldValidate: true, form: this.state.form.validate()}, () => {
			this.state.form.onValid(this.props.onSubmit);
		});
	}
}
